/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Destaque mensagens importantes com um realce visual. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Saiba mais sobre realces',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Destaque mensagens importantes com um realce visual.',
  'company-hub.spotlight-extension.config-panel.title': 'Realce',
  'company-hub.spotlight-extension.hub-element.description': 'Destaque mensagens importantes',
  'company-hub.spotlight-extension.hub-element.title': 'Realce',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Fotografia de paisagem do deserto',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Crie um realce para destacar as informações mais importantes. Dê vida às mensagens mais importantes com cores personalizadas, uma imagem poderosa e layouts flexíveis.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Dê um título ao seu realce',
  'company-hub.spotlight-extension.manifest.macro-description': 'Destaque mensagens importantes com um realce visual.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Realce',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Realce [novidade]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Conteúdo',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'Geral',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Layouts',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Sobreposição de caixa de texto em uma imagem grande',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Quadro de conteúdo dentro da imagem',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Imagem em tamanho real usada como fundo do seu conteúdo',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Imagem de plano de fundo',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Conteúdo sobre um fundo colorido',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label':
    'Plano de fundo com cor sólida',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Imagem grande à direita com muito espaço para conteúdo',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Design dividido (conteúdo em primeiro lugar)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Imagem grande à esquerda com muito espaço para conteúdo',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Design dividido (imagem em primeiro lugar)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Estilos',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Descrição',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Os realces destacam mensagens importantes para sua equipe. Crie o realce com uma imagem, suas cores personalizadas, uma breve descrição e um link.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Imagem',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Cargo',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Dê um título ao seu realce',
  'company-hub.spotlight-extension.spotlight.background.color': 'Cor do plano de fundo',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Suas cores de texto e plano de fundo não facilitam a leitura.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'As cores do texto e do plano de fundo facilitam a leitura.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Cor do texto',
};
